import React, { useState } from 'react';
import { supabase } from '../lib/supabase';
import '../styles/Join.css';

interface Props {
  email: string;
  appUserId: string | null;
}

function JoinPage({ email, appUserId }: Props) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const pay = async () => {
    if (!appUserId) return;
    setBusy(true);
    setError('');
    try {
      const res = await fetch('/.netlify/functions/create-checkout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, appUserId }),
      });
      const data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        setError('Could not start checkout. Please try again.');
        setBusy(false);
      }
    } catch {
      setError('Could not start checkout. Please try again.');
      setBusy(false);
    }
  };

  return (
    <div className="join-page">
      <div className="join-card">
        <img src="/logo.png" alt="Lighthouse Hunters" className="join-logo" />
        <h1>Membership</h1>
        <p className="join-price">
          <span>$99</span> per year, inc. GST
        </p>
        <ul className="join-list">
          <li>Over 200 Australian lighthouses to hunt</li>
          <li>GPS verified stamps across Standard, Extreme and Heritage passports</li>
          <li>Your own photo gallery on every stamp</li>
          <li>Photos and tips from members at every lighthouse page</li>
        </ul>
        <button className="btn-primary" onClick={pay} disabled={busy || !appUserId}>
          {busy ? 'Taking you to payment...' : 'Join now'}
        </button>
        <p className="join-fine" style={{ fontWeight: 600, marginTop: '10px' }}>
          Change your mind within 14 days and we refund in full, no questions asked.
        </p>
        {error && <p className="join-error">{error}</p>}
        <p className="join-fine">
          Secure payment by Stripe. Renews yearly, cancel any time. Signed in as {email}.
        </p>
        <button className="join-signout" onClick={() => supabase.auth.signOut()}>
          Sign out
        </button>
      </div>
    </div>
  );
}

export default JoinPage;
